import { Grid, FormControl, InputLabel, MenuItem, Select, Button, Link, TextField } from '@mui/material'
import React, { useState, useEffect } from 'react';
import Loader from '../../Components/loader';
import ImageComponents from '../../../../Shared/ImageComponents';
import CustomizedDialogs from '../../../../Shared/CustomDialogs';


function AadharEmandate({ payModesToPass }) {

	const [selectBankName, setBankName] = useState('');
	const [selectBankCode, setBankCode] = useState('');
	const [bankList, setBankList] = useState(null);
	const [txnurl, settxnurl] = useState('');
	const [pgpayload, setpgpayload] = useState('');
	const [codeList, setcodeList] = useState('');
	const [NBerror, setNBerror] = useState(false);
	const [showLoader, setshowLoader] = useState(false);
	const queryParameters = new URLSearchParams(window.location.search);
	const error = queryParameters.get("error");
	const [selectBank, setAadharBank] = React.useState('');

	const handleSelectChange = (event) => {
		console.log("event" + event.target.value);
		setAadharBank(event.target.value);
	};

	let form;
	useEffect(() => {
		if (payModesToPass) {

			const aadhaarEmandateMethod = payModesToPass.find(method => method.code === 'EMANDATE_ADHR');
			const aadhaarBanks = aadhaarEmandateMethod ? aadhaarEmandateMethod.subPayModes : null;
			setBankList(aadhaarBanks);

			var bankcodes = [];
			if (aadhaarBanks) {
				aadhaarBanks.forEach(function (item) {
					bankcodes.push(item.code);
				});

				setcodeList(bankcodes);
			}
			console.log("bankcodes" + bankcodes);

		}
	}, [payModesToPass]);

	const handleChange = (event) => {
		setNBerror(false);
		const selectedBankCode = event.target.value;
		const selectedBank = bankList.find(bank => bank.code === selectedBankCode);
		setBankName(selectedBank.name);
		setBankCode(selectedBankCode);

	};


	useEffect(() => {
		if (selectBankCode) {
			const selectedBank = bankList.find(bank => bank.code === selectBankCode);
			setBankName(selectedBank.name);
		}
		setNBerror(false);
	}, [selectBankCode]);

	const handlePayNow = async () => {
		if (selectBankCode > 0) {
			setshowLoader(true);
			const queryParameters = new URLSearchParams(window.location.search);
			const order = queryParameters.get("orderNo");
			const mode = "NB";
			const nbCode = selectBankCode;

			try {
				const response = await fetch('/pay/securePayment/process/paymentui', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						orderNo: order,
						mode: mode,
						nbCode: selectBankCode

					})
				});
				const data = await response.json();


				if (data.as === 1) {
					if (data.pgPayload.form) {
						const formHtml = data.pgPayload.form;
						const tempContainer = document.createElement('div');
						tempContainer.innerHTML = formHtml;

						const formElement = tempContainer.querySelector('form');
						document.body.appendChild(formElement);
						formElement.submit();
					}
					else if (data.txnURL) {
						settxnurl(data.txnURL);
						setpgpayload(data.pgPayload);
						await delay(1500);
						form = document.getElementById('testForm');
						form.submit();

					}
				}
			} catch (error) {
				console.error('Error:', error);
			}
		} else {
			setNBerror(true);
		}
	};

	const delay = millis => new Promise((resolve, reject) => {
		setTimeout(_ => resolve(), millis)
	});

	return (
		<>

			{showLoader && <Loader show={true} textToShow="Please wait while your transaction is being processed" />}
			{pgpayload && (
				<form method="post" action={txnurl} id="testForm">
					{Object.keys(pgpayload).map((key, index) => (
						<input key={index} type="hidden" id={key} name={key} value={pgpayload[key]} />
					))}
				</form>
			)}




			<div className='card-details'>
				<div className='card-detail-form'>
					<h5>
						To register Autopay provide below details
					</h5>


					<Grid container spacing={3}>

						<Grid item md={12} xs={12} >
							<FormControl fullWidth className='form-control'>
								<InputLabel id="demo-simple-select-label">Select your bank</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={selectBankCode}
									label="Bank Name"
									onChange={handleChange}
									error={NBerror}
									helperText={NBerror}
								>
									{bankList && bankList.map((bank, index) => (
										<MenuItem key={index} value={bank.code}>
											{bank.name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>

						<Grid item md={12} xs={12}>
							<InputLabel id="outlined-required">Select account type</InputLabel>
							<FormControl fullWidth className="form-control">
								<div className="radio-option" style={{ display: 'flex', gap: '45px' }}>
									<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
										<input type="radio" id="savingsAD" name="radio-group-ad" defaultChecked />
										<label htmlFor="savingsAD">Savings</label>
									</div>

									<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
										<input type="radio" id="currentAD" name="radio-group-ad" />
										<label htmlFor="currentAD">Current</label>
									</div>

									<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
										<input type="radio" id="otherAD" name="radio-group-ad" />
										<label htmlFor="otherAD">Other</label>
									</div>
								</div>
							</FormControl>
						</Grid>



						<Grid item md={12} xs={12}>
							<TextField
								id="outlined-required"
								label="Your account number"
								fullWidth
								style={{ borderRadius: '8px' }}
							/>
						</Grid>
						<Grid item md={12} xs={12}>
							<TextField
								id="outlined-required"
								label="Your IFSC code"
								fullWidth
								style={{ borderRadius: '8px' }}
							/>
						</Grid>




					</Grid>


					{NBerror && (
						<p style={{ color: 'red' }}>Please select a bank!</p>
					)}
					<div className="mt-4">
						<Button variant="outlined" size="large" className='pay-now-btn' onClick={handlePayNow}>
							Pay Now
						</Button>
					</div>


				</div>
			</div >
		</>
	)
}

export default AadharEmandate
